import { PropsWithChildren } from 'react';
import { DatasourceUpgradeStatusIcon } from '../../upgrade/statusIcon/DatasourceUpgradeStatusIcon';
import { DatasourceUpgradeFieldStatus } from '@/lib/datasource/upgrade/datasourceUpgrade.types';

export const DatasourceReviewLabel = ({
  status,
  children,
}: PropsWithChildren<{ status?: DatasourceUpgradeFieldStatus }>) => {
  if (!status) {
    return <>{children}</>;
  }
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm">{children}</span>
      <DatasourceUpgradeStatusIcon status={status} />
    </div>
  );
};
